import { render, staticRenderFns } from "./AdminDemand.vue?vue&type=template&id=281fd438&"
import script from "./AdminDemand.vue?vue&type=script&lang=js&"
export * from "./AdminDemand.vue?vue&type=script&lang=js&"
import style0 from "./AdminDemand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports